import React from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';

import CrawlerTable from '@hydra/routes/crawler/components/CrawlerTable';
import DisallowedPagesRow from '../DisallowedPagesRow';

import FilterContainer from '@hydra/routes/crawler/components/FilterContainer';
import FilterCheckboxes from '@hydra/routes/crawler/components/FilterCheckboxes';
import FilterString from '@hydra/routes/crawler/components/FilterString';
import { withFilters } from '@hydra/routes/crawler/components/withFilters';

const SITEMAP_FILTERS = [
  { identifier: 'showInSitemap', value: 'showInSitemap' },
  { identifier: 'showNotInSitemap', value: 'showNotInSitemap' }
];

export class DisallowedPagesTable extends React.Component {
  static propTypes = {
    relay: PropTypes.object,
    project: PropTypes.shape({
      crawl: PropTypes.shape({
        indexingCategory: PropTypes.shape({
          disallowedPages: PropTypes.shape({
            count: PropTypes.number,
            edges: PropTypes.arrayOf(
              PropTypes.shape({
                node: PropTypes.object
              })
            )
          })
        })
      })
    }).isRequired,
    offset: PropTypes.number,
    limit: PropTypes.number
  }

  render () {
    return (
      <>
        <FilterContainer>
          <FilterString
            onChange={this.props.onGraphQLInputChange('url')}
            value={this.props.filters.url}
            name='url'
            label={<Translate content='crawler_disallowed_page_url' />}
          />

          <FilterString
            onChange={this.props.onGraphQLInputChange('sourceUrl')}
            value={this.props.filters.sourceUrl}
            name='sourceUrl'
            label={<Translate content='crawler_source_page_url' />}
          />

          <FilterCheckboxes
            onChange={this.props.onGraphQLCheckboxInputChange('sitemapFilter', SITEMAP_FILTERS, true)}
            checkedItems={this.props.filters.sitemapFilter}
            groups={SITEMAP_FILTERS}
            name='sitemapFilter'
            label={<Translate content='crawler_linking_sitemap_check' />}
          />
        </FilterContainer>
        <CrawlerTable {...this.props} category='indexingCategory' section='disallowedPages'>
          <CrawlerTable.TableHead>
            <Translate content='crawler_disallowed_page_url' size='4' />
            <Translate content='crawler_source_page_url' size='4' />
            <Translate content='crawler_linking_sitemap_check' size='4' />
          </CrawlerTable.TableHead>
          <CrawlerTable.Body component={DisallowedPagesRow} />
        </CrawlerTable>
      </>
    );
  }
}

const WithFiltersTable = (withFilters)(DisallowedPagesTable);

export default createRefetchContainer(
  WithFiltersTable,
  {
    project: graphql`
      fragment DisallowedPagesTable_project on Project
      @argumentDefinitions(
        offset: {type: "Int", defaultValue: 0},
        limit: {type: "Int", defaultValue: 20},
        url: {type: "TextFilters", defaultValue: { operator: AND, values: [] }},
        sourceUrl: {type: "TextFilters", defaultValue: { operator: AND, values: [] }},
        sitemapFilter: { type: "SitemapFilter", defaultValue: { showInSitemap: true, showNotInSitemap: true } }
      ) {
        host,
        crawls (offset: 0, limit: 1) {
          edges {
            node {
              disallowedPages(offset: $offset, limit: $limit, url: $url, sourceUrl: $sourceUrl, sitemapFilter: $sitemapFilter) {
                count
                edges {
                  node {
                    ...DisallowedPagesRow_issue
                  }
                }
              }
            }
          }
        }
      }
    `
  },
  graphql`
      query DisallowedPagesTable_RefetchQuery(
        $host: String!
        $limit: Int,
        $offset: Int,
        $sitemapFilter: SitemapFilter,
        $sourceUrl: TextFilters,
        $url: TextFilters) {,
        project (host: $host) {
          ...DisallowedPagesTable_project @arguments(
            offset: $offset,
            limit: $limit,
            sitemapFilter: $sitemapFilter,
            url: $url,
            sourceUrl: $sourceUrl
          )
        }
      }
    `
);
